@let content = currentRendering.selectors.content.asSignal();
@let segments = content?.scrolling ?? [];

<atn-ds-page>
  <atn-mosaic-page-header pageHeader />

  <ng-container pageAside>
    <!-- TODO: to implement stepper being properly connected to the proper
  segment, we would need to rework 'stepper.component' in a way, so it doesn't
  query by DOM, but we instead use directive -->
    <span style="font-style: italic; font-size: 8px">
      TODO: stepper is not really connected to scroll to appropriate segment
    </span>
    <atn-ds-stepper [connectedTo]="body">
      @for (segment of segments; track $index) {
        <atn-ds-stepper-item [id]="segment.alias">
          {{ segment.name }}
        </atn-ds-stepper-item>
      }
    </atn-ds-stepper>
  </ng-container>

  <div #body>
    @for (segment of segments; track $index) {
      <atn-mosaic-page-grid [container]="segment" />
    }
  </div>
</atn-ds-page>
